import { type FC } from 'react';
import PiiConfirmation from '../PiiConfirmation/Default';
import ExitStrategy from '../ExitStrategy/Default';
import AdditionalQuestions from '../AdditionalQuestions';
import SubmissionStatusPanel from '../SubmissionStatus';
import type { SingleProgramSubmissionProps } from './types';
import SingleProgramSubmission from './index';

/**
 * Single unified single-program-submission step. Replaces the legacy
 * `SingleProgramSubmission/variants/{UnderGradSingleProgramSubmission,
 * GradSingleProgramSubmission}.tsx` pair. The shared
 * `SingleProgramSubmission` shell still picks the renderer per
 * `SingleSubmissionStep`, but every leg now points at the unified
 * Default step components rather than per-variant ones.
 */
const SingleProgramSubmissionDefault: FC<SingleProgramSubmissionProps> = (
  props,
) => (
  <SingleProgramSubmission
    {...props}
    PiiConfirmationComponent={PiiConfirmation}
    ExitStrategyComponent={ExitStrategy}
    AdditionalQuestionsComponent={AdditionalQuestions}
    SubmissionStatusComponent={SubmissionStatusPanel}
  />
);

export default SingleProgramSubmissionDefault;
